import React from 'react';
import {
  classNames,
  headingClassNames,
  HeadingClassNameProps,
  layoutClassNames,
  LayoutClassNameProps,
  surfaceClassNames,
  SurfaceClassNameProps,
} from './classNames';

export type AlertVariant =
  | 'primary'
  | 'secondary'
  | 'success'
  | 'danger'
  | 'warning'
  | 'info'
  | 'light'
  | 'dark';

export interface AlertProps
  extends React.HTMLAttributes<HTMLDivElement>,
    LayoutClassNameProps,
    Pick<SurfaceClassNameProps, 'bordered' | 'borderColor' | 'rounded' | 'shadow'> {
  variant?: AlertVariant;
  fullWidth?: boolean;
}

const Alert: React.FC<AlertProps> = ({
  variant = 'info',
  fullWidth = false,
  role = 'alert',
  className,
  children,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  bordered,
  borderColor,
  rounded,
  shadow,
  ...props
}) => (
  <div
    role={role}
    className={classNames(
      'alert',
      `alert-${variant}`,
      fullWidth ? 'w-100' : undefined,
      surfaceClassNames({
        bordered,
        borderColor,
        rounded,
        shadow,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </div>
);

export interface AlertHeadingProps
  extends React.HTMLAttributes<HTMLElement>,
    HeadingClassNameProps,
    LayoutClassNameProps {
  as?: React.ElementType;
}

export const AlertHeading: React.FC<AlertHeadingProps> = ({
  as: Component = 'h4',
  className,
  children,
  displaySize,
  margin,
  marginTop,
  marginEnd,
  marginBottom,
  marginStart,
  marginX,
  marginY,
  padding,
  paddingTop,
  paddingEnd,
  paddingBottom,
  paddingStart,
  paddingX,
  paddingY,
  textAlign,
  visualLevel,
  ...props
}) => (
  <Component
    className={classNames(
      'alert-heading',
      headingClassNames({
        displaySize,
        visualLevel,
      }),
      layoutClassNames({
        margin,
        marginTop,
        marginEnd,
        marginBottom,
        marginStart,
        marginX,
        marginY,
        padding,
        paddingTop,
        paddingEnd,
        paddingBottom,
        paddingStart,
        paddingX,
        paddingY,
        textAlign,
      }),
      className,
    )}
    {...props}
  >
    {children}
  </Component>
);

export default Alert;
